import { Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import React from 'react';
import { API_PATH } from 'config';

const styles = StyleSheet.create({
  header: {
    position: 'absolute',
    top: '0px',
    left: '0px',
    right: '0px',
    height: '3.5cm',
    backgroundColor: '#ffffff',
    borderBottom: '2px solid #548235',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: '1.5cm',
    paddingVertical: '0.4cm',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  logoContainer: {
    backgroundColor: '#ffffff',
    padding: '0.2cm',
    borderRadius: '0.2cm',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    border: '1px solid #e0e0e0',
  },
  logo: {
    width: '2.5cm',
    height: '1.8cm',
    objectFit: 'contain',
  },
  centerSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
    marginHorizontal: '1cm',
  },
  companyTitle: {
    fontFamily: 'Helvetica-Bold',
    fontSize: '14px',
    color: '#2c3e50',
    textAlign: 'center',
    marginBottom: '0.1cm',
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
  },
  companySubtitle: {
    fontFamily: 'Helvetica',
    fontSize: '10px',
    color: '#7f8c8d',
    textAlign: 'center',
    fontStyle: 'italic',
  },
  rightSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    minWidth: '3cm',
  },
  contactInfo: {
    fontFamily: 'Helvetica',
    fontSize: '8px',
    color: '#34495e',
    lineHeight: 1.2,
    textAlign: 'right',
    marginBottom: '0.1cm',
  },
  contactLabel: {
    fontFamily: 'Helvetica-Bold',
    fontSize: '7px',
    color: '#548235',
    textTransform: 'uppercase',
    letterSpacing: '0.2px',
  },
});

function BudgetHeader({ config, staticData }) {
  return (
    <View fixed style={styles.header}>
      {/* Logo Section */}
      <View style={styles.logoContainer}>
        {config?.portraitLogo ? (
          <Image style={styles.logo} source={`${API_PATH}${config?.portraitLogo}`} />
        ) : null}
      </View>

      {/* Center Section - Company Info */}
      <View style={styles.centerSection}>
        <Text style={styles.companyTitle}>{staticData?.secondary_title ?? ''}</Text>
        <Text style={styles.companySubtitle}>Soluciones en Elevación y Mantenimiento</Text>
      </View>

      {/* Right Section - Contact Info */}
      <View style={styles.rightSection}>
        {staticData?.right_header_1 && (
          <Text style={styles.contactInfo}>{staticData.right_header_1}</Text>
        )}
        {staticData?.right_header_2 && (
          <Text style={styles.contactInfo}>{staticData.right_header_2}</Text>
        )}
        {staticData?.right_header_3 && (
          <Text style={styles.contactInfo}>{staticData.right_header_3}</Text>
        )}
      </View>
    </View>
  );
}

export default BudgetHeader;
